<template>
  <!-- 警报点节点信息 -->
  <div>
    <!--      <div class="crumbs">-->
    <!--        <el-breadcrumb separator="/">-->
    <!--          <el-breadcrumb-item>警报点</el-breadcrumb-item>-->
    <!--          <el-breadcrumb-item>警报点节点信息</el-breadcrumb-item>-->
    <!--        </el-breadcrumb>-->
    <!--      </div>-->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>警报点节点信息</span>
        <!--          <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
      </div>
      <el-form label-position="left" inline class="demo-table-expand">
        <!--<el-form-item label="编号">-->
        <!--<span >{{alarmPointInfo.alarmPointId}}</span>-->
        <!--</el-form-item>-->
        <div class="tonghang" >
          <el-form-item label="点位名称">
            <span>{{AlarmPointStaticInfomation.pointName}}</span>
          </el-form-item>
          <el-form-item label="台站类型">
            <span>{{AlarmPointStaticInfomation.alarmPointType}}</span>
          </el-form-item>
        </div>

        <div class="tonghang" >
          <el-form-item label="纬度">
            <span>{{AlarmPointStaticInfomation.longitude}}</span>
          </el-form-item>
          <el-form-item label="经度">
            <span>{{AlarmPointStaticInfomation.latitude}}</span>
          </el-form-item>
        </div>

        <div class="tonghang" >
          <el-form-item label="街道">
            <span>{{AlarmPointStaticInfomation.areaName}}</span>
          </el-form-item>
          <el-form-item label="警音半径">
            <span>{{AlarmPointStaticInfomation.alarmRadius}}</span>
          </el-form-item>
        </div>

        <div class="tonghang" >
          <el-form-item label="安装时间">
            <span>{{AlarmPointStaticInfomation.installAt}}</span>
          </el-form-item><br>
          <el-form-item label="备注">
            <span>{{AlarmPointStaticInfomation.remark}}</span>
          </el-form-item>
        </div>

      </el-form>
      <!--        <el-form label-position="left" inline class="demo-table-expand">-->
      <!--          <div class="tonghang" >-->
      <!--            <el-form-item label="" style="color: black;"></el-form-item>-->
      <!--          </div>-->
      <!--          <div class="tonghang" >-->
      <!--            <el-form-item label="设备信息" style="color: black;"></el-form-item>-->
      <!--          </div>-->
      <!--          <div class="tonghang" >-->
      <!--            <el-form-item label="设备ID">-->
      <!--              <span>{{AlarmPointStaticInfomation.devID}}</span>-->
      <!--            </el-form-item>-->
      <!--            <el-form-item label="设备用户" v-if="typeof(DeviceUser.username) !== 'undefined'">-->
      <!--              <span>{{DeviceUser.username}}</span>-->
      <!--            </el-form-item>-->
      <!--          </div>-->
      <!--          <div class="tonghang" >-->
      <!--            <el-form-item label="密码" v-if="typeof(DeviceUser.password) !== 'undefined'">-->
      <!--              <span>{{DeviceUser.password}}</span>-->
      <!--            </el-form-item>-->
      <!--          </div>-->
      <!--        </el-form>-->
      <!--<el-button @click="getDeviceUser"  style="margin-top: 15px;">获取设备用户列表</el-button>-->
      <!--<el-button @click="getDataKey"  style="margin-top: 15px;">获取动态数据的数据字段</el-button>-->
      <!--        <el-button @click="openAddDeviceUserDialog" type="primary" style="margin-top: 15px;">添加设备用户</el-button>-->
    </el-card>
    <AddDeviceUser :add-device-user-dialog-visible="addDeviceUserDialogVisible" :dev-i-d="AlarmPointStaticInfomation.devID" @feedBack="getAddDeviceUserFeedBack"></AddDeviceUser>
  </div>
</template>

<script>
  import AlarmViewNav from './AlarmViewNav'
  import AddDeviceUser from './device/AddDeviceUser'
  export default {
    name: 'AlarmPointView',
    components: { AddDeviceUser, AlarmViewNav },
    data(){
      return {
        addDeviceUserDialogVisible: false,
        alarmPointInfo:'',
        // 获取区域列表
        GetAreaList:{
          "version": 1,
          "method": "area.GetAreaList",
          "params": null,
          "token": "",
          "id": 0
        },
        // 获取动态数据的数据字段
        GetDataKey:{
          "version": 1,
          "method": "alarm.GetDataKey",
          "params": null,
          "token": "",
          "id": 0
        },
        // 查询设备账户
        GetDeviceUser:{
          "version": 1,
          "method": "user.GetDeviceUser",
          "params": {
            "devID":"",
          },
          "token": "",
          "id": 0
        },
        DeviceUser:{
          "_id":"",
          "username":"",
          "password":"",
          "devID":"",
          "deletedFlag":"",
          "userType":"",
          "token":""
        },
      }
    },
    methods:{
      openAddDeviceUserDialog(){
        console.log('打开添加设备用户模态框');
        this.addDeviceUserDialogVisible = true
      },
      getDataKey(){
        this.GetDataKey.token =  localStorage.getItem('token');
        console.log('获取动态数据的数据字段请求');
        console.log(this.GetDataKey)
        this.$axios.post(this.$mainUrl, this.GetDataKey).then(res=>{
          console.log('获取动态数据的数据字段请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){

          }else{
            this.$message({
              type: 'error',
              message: '获取动态数据的数据字段失败，' + res.data.error.message
            })
          }
        })
      },
      // 获取设备账户
      getDeviceUser(){
        this.GetDeviceUser.token =  localStorage.getItem('token');
        this.GetDeviceUser.params.devID =  window.sessionStorage.getItem('devIDForHardInfo')
        console.log('获取设备账户请求');
        console.log(this.GetDeviceUser)
        this.$axios.post(this.$mainUrl, this.GetDeviceUser).then(res=>{
          console.log('添加维修记录请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result') && res.data.result.hasOwnProperty('deviceUser')){
            this.DeviceUser = res.data.result.deviceUser;

          }else if(res.data.hasOwnProperty('error')){
            this.$message({
              type: 'error',
              message: '获取设备账户失败，' + res.data.error.message
            })
          }
        })
      },
      getAddDeviceUserFeedBack(addDeviceUserDialogVisible){
        this.addDeviceUserDialogVisible = addDeviceUserDialogVisible;
        this.getDeviceUser();
      }
    },
    computed:{
      AlarmPointStaticInfomation(){
        return this.$store.state.AlarmPointStaticInfomation.result;
      }
    },
    mounted () {
      // this.getAreaList();
      this.getDeviceUser();
      // this.debug = this.$store.state.AlarmPointStaticInfomation;
    }

  }
</script>

<style scoped>
  .tonghang{
    display: flex; flex-wrap: nowrap;
  }
</style>
<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
